<template>
  <section class="banner" :class="isHome?'':'bg_banner'">
    <div class="container">
      <a-typography-title :level="1">
        企业级数字人私有化部署方案
      </a-typography-title>
      <a-space size="small" class="banner_text">
        <p>安全可控</p>｜<p>深度定制</p>｜<p>灵活扩展</p>
      </a-space>
      <a-space :size="$Store.Public().isGridMatch('>=',$Enum.GridEnum.XL)?'large':'small'" class="banner_button">
        <a-button type="link" class="button_n_1" @click="$Store.Page().openModal('modalFormCollection','productPrivateAidigitalHumanGetPlan')" style="width:135px !important">
          立即获取方案
        </a-button>
        <a-button type="link" class="button_n_1" @click="$Store.Page().openModal('modalFormCollection','productPrivateAidigitalHuman')">
          预约技术演示
        </a-button>
      </a-space>
    </div>
  </section>
</template>

<script lang="ts" type="text/tsx">
import { DataInterface } from "@interface/public";
import { AndroidOutlined } from "@ant-design/icons-vue";

export default {
  name: "product_banner",
  props: ["isHome"],
  components: { AndroidOutlined },
  methods: {
    /**
     * 点击去AI数字人
     */
    clickToAidigitalHuman(): void {
      // location.href = 'https://galaxy-future.feishu.cn/docx/BpfYdxcOYoNbXYxEHk8ce0OHnLd';
      open($Config.Href.aiavatars);
    },
  },
};
</script>

<style lang="less" rel="stylesheet/less" scoped>
@import "@resource/css/_global.less";

@image: "@{src_image}page/productSchedulX/";

.bg_banner {
  .bg("@{src_image}page/home/banner_productPrivateAidigitalHuman.png");
}
.banner {
  overflow: hidden;
  position: relative;
  z-index: 0;
  padding: 60px @padding;
  background-size: cover;
  &_text {
    .font(justify, @text+@line, @color_white, @text);
    .fontSpacing(2px);
    text-shadow: 0 2px 5px fade(#10388c, 100);
    display: flex;
    align-items: center;
    margin-bottom: 40px;
  }

  .container {
    position: relative;
    max-width: @grid_xl;
    padding: 120px 0 50px;
    margin: 0 auto;
    .borderBox();
  }
}

h1.ant-typography {
  margin: 0;
  .font(justify, @banner_title, @color_white, @banner_title);
}

div.ant-typography {
  max-width: 550px;
  margin: 20px 0 0;
  padding: 10px 0;
  .font(justify, @text+@line, @color_white, @text);
  .fontSpacing(2px);
  text-shadow: 0 2px 5px fade(#10388c, 100);
  position: relative;
  &::before {
    content: "";
    display: block;
    .center();
    z-index: -1;
    .bg("@{src_image}page/home/banner_text.png", 110%, 100%, true);
  }
}

.ant-space {
  margin-top: 20px;
}

@media screen and (max-width: -1px+@grid_xl) {
  .banner {
    .container {
      padding: 80px 0 30px;
    }
  }
}

@media screen and (max-width: -1px+@grid_md) {
  h1.ant-typography {
    .font(justify, @banner_title_mo, @color_white, @banner_title_mo, true);
  }

  div.ant-typography {
    margin: 10px 0 0;
    .font(justify, @text_mo+@line_mo, @color_white, @text_mo);
  }

  .ant-space {
    margin-top: 10px;
  }
}

@media screen and (max-width: -1px+@grid_xs) {
  .banner {
    background-position: center left !important;
  }
}
</style>